import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },*/
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'Offer No',
     label: 'Offer No',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'dateOfOffer',
     field: FIELDS.DATE_OF_OFFER,
     title: 'Date Offered',
     label: 'Date Offered',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     
     cell: 'navigation',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'mfr',
     field: FIELDS.MFR,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Vendor',
     label: 'Vendor',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorType',
     field: FIELDS.VENDOR_TYPE,
     title: 'V Type',
     label: 'V Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'companyRating',
     field: FIELDS.COMPANY_RATING,
     title: 'V Rating',
     label: 'V Rating',
     cell: 'formatRatingAsWord',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contactFullName',
     field: FIELDS.CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contactEmail',
     field: FIELDS.CONTACT_EMAIL,
     title: 'Email',
     label: 'Email',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactPhone',
     field: FIELDS.CONTACT_PHONE,
     title: 'Phone',
     label: 'Phone',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Qty Offered',
     label: 'Qty Offered',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isInStock',
     field: FIELDS.IS_IN_STOCK,
     title: 'Stock',
     label: 'Stock',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isFullLabelTraceable',
     field: FIELDS.IS_FULL_LABEL_TRACEABLE,
     title: 'Traceable',
     label: 'Traceable',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isLotCodeRemoved',
     field: FIELDS.IS_LOT_CODE_REMOVED,
     title: 'LC Removed',
     label: 'LC Removed',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isMfrCocPackList',
     field: FIELDS.IS_MFR_COC_PACK_LIST,
     title: 'MFR COC/Pack List',
     label: 'MFR COC/Pack List',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isFranchiseCocPackList',
     field: FIELDS.IS_FRANCHISE_COC_PACK_LIST,
     title: 'Fran COC/Pack List',
     label: 'Fran COC/Pack List',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isNotTraceable',
     field: FIELDS.IS_NOT_TRACEABLE,
     title: 'No Trace',
     label: 'No Trace',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'cost',
     field: FIELDS.COST,
     title: 'Cost',
     label: 'Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'delivery',
     field: FIELDS.DELIVERY,
     title: 'Lead Time',
     label: 'Lead Time',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantityAvail',
     field: FIELDS.QUANTITY_AVAIL,
     title: 'Qty Avail',
     label: 'Qty Avail',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'moq',
     field: FIELDS.MOQ,
     title: 'MOQ',
     label: 'MOQ',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorCost',
     field: FIELDS.COST,
     title: 'Vendor Cost',
     label: 'Vendor Cost',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'conditionName',
     field: FIELDS.CONDITION_NAME,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'warrantyName',
     field: FIELDS.WARRANTY_NAME,
     title: 'V Warranty',
     label: 'V Warranty',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comment',
     field: FIELDS.COMMENT,
     title: 'Vendor Notes',
     label: 'Vendor Notes',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Item Pkg',
     label: 'Item Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerPN',
     field: FIELDS.CUSTOMER_PN,
     title: 'Customer PN',
     label: 'Customer PN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Rev',
     label: 'Rev',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'convertedCost',
     field: FIELDS.CONVERTED_COST,
     title: 'Conv Cost',
     label: 'Conv Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tested',
     field: FIELDS.TESTED,
     title: 'Tested',
     label: 'Tested',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altNumber',
     field: FIELDS.ALT_NUMBER,
     title: 'Alt Number',
     label: 'Alt Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalPN',
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'inventoryClassName',
     field: FIELDS.INVENTORY_CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'inventoryCategoryName',
     field: FIELDS.INVENTORY_CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS Code',
     label: 'HTS Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'scheduleB',
     field: FIELDS.SCHEDULE_B,
     title: 'Sched B',
     label: 'Sched B',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;

export const addSourceOffersFields = [
   {
     field: FIELDS.ID,
     title: 'ID',
     sortable: true,
     hidden: false,
     width: 70,
   },  
   {
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     locked: true,
     width: 200,
   },
   {
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 300,
   },
   {
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Qty',
     label: 'Qty',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 65,
   },
   
   {
     key: 'QuantityAvail',
     field: FIELDS.QUANTITY_AVAIL,
     title: ' Quantity Avail',
     label: 'QuantityAvail',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 65,
   },
   {
     key: 'mOQ',
     field: FIELDS.MOQ,
     title: 'MOQ',
     label: 'MOQ',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 65,
   },
   {
     key: 'vendorCost',
     field: FIELDS.VENDOR_COST,
     title: 'Cost',
     label: 'Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 90,
   },
   {
     key: 'customerPN',
     field: FIELDS.CUSTOMER_PN,
     title: 'Customer PN',
     label: 'Customer PN',
     sortable: true,
     hidden: false,
     width: 200,
   },
   {
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: false,
     width: 400,
   },
   {
     key: 'mfr',
     field: FIELDS.MFR,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 300,
   },
   {
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 70,
   },
   {
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: false,
     width: 70,
   },
   {
     field: FIELDS.REVISION,
     title: 'Rev',
     label: 'Rev',
     sortable: true,
     hidden: false,
     width: 50,
   },
   {
     key: 'IsInStock',
     field: FIELDS.IS_IN_STOCK,
     title: ' Is In Stock',
     label: 'IsInStock',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 50,
   },
   {
     key: 'IsFullLabelTraceable',
     field: FIELDS.IS_FULL_LABEL_TRACEABLE,
     title: ' Is Full Label Traceable',
     label: 'IsFullLabelTraceable',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 50,
   },
   {
     key: 'IsLotCodeRemoved',
     field: FIELDS.IS_LOT_CODE_REMOVED,
     title: ' Is Lot Code Removed',
     label: 'IsLotCodeRemoved',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 50,
   },
   {
     key: 'IsMfrCocPackList',
     field: FIELDS.IS_MFR_COC_PACK_LIST,
     title: ' Is Mfr Coc Pack List',
     label: 'IsMfrCocPackList',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 50,
   },
   {
     key: 'IsFranchiseCocPackList',
     field: FIELDS.IS_FRANCHISE_COC_PACK_LIST,
     title: ' Is Franchise Coc Pack List',
     label: 'IsFranchiseCocPackList',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 50,
   },
   {
     key: 'IsNotTraceable',
     field: FIELDS.IS_NOT_TRACEABLE,
     title: ' Is Not Traceable',
     label: 'IsNotTraceable',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 50,
   },
   {
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Package',
     label: 'Package',
     sortable: true,
     hidden: false,
     width: 180,
   },
   {
     field: FIELDS.PHYSICAL_PACKAGE,
     title: 'PhysPkg',
     label: 'PhysPkg',
     sortable: true,
     hidden: false,
     width: 180,
   },
   {
     field: FIELDS.PIECES_PER_PACKAGE,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'condition',
     field: FIELDS.CONDITION,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: false,
     width: 125,
   },
   {
     key: 'dateOfOffer',
     field: FIELDS.DATE_OF_OFFER,
     title: 'Date Offered',
     label: 'Date Offered',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 110,
   },
   {
     key: 'delivery',
     field: FIELDS.DELIVERY,
     title: 'Delivery',
     label: 'Delivery',
     sortable: true,
     hidden: false,
     width: 100,
   },
   {
     key: 'warranty',
     field: FIELDS.WARRANTY,
     title: 'Warranty',
     label: 'Warranty',
     sortable: true,
     hidden: false,
     width: 100,
   },
   {
     field: FIELDS.COMMENT,
     title: 'Vendor Note',
     label: 'Vendor Note',
     sortable: true,
     hidden: false,
     width: 200,
   },
   {
     field: FIELDS.CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: true,
     width: 90,
   },
   {
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     sortable: true,
     hidden: true,
     width: 50,
   },
   {
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     sortable: true,
     hidden: true,
     width: 80,
   },
   {
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: true,
     width: 90,
   },
   {
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     sortable: true,
     hidden: true,
     width: 80,
   },
   {
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 90,
   },
   {
     field: FIELDS.CONVERTED_COST,
     title: 'Conv Cost',
     label: 'Conv Cost',
     sortable: true,
     hidden: true,
     width: 70,
   },
   {
     field: FIELDS.TESTED,
     title: 'Tested',
     label: 'Tested',
     sortable: true,
     hidden: true,
     width: 70,
   },
   {
     field: FIELDS.ALT_NUMBER,
     title: 'Alt Number',
     label: 'Alt Number',
     sortable: true,
     hidden: true,
     width: 200,
   },
   {
     field: FIELDS.NSN_NUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: true,
     width: 200,
   },
   {
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 200,
   },
   {
     field: FIELDS.INVENTORY_CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 180,
   },
   {
     field: FIELDS.INVENTORY_CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 180,
   },
   {
     field: FIELDS.VENDOR_RFP_NUMBER,
     title: 'RFP No',
     label: 'RFP No',
     sortable: true,
     hidden: true,
     width: 100,
   },
   {
    field: 'deletecommands',
    title: '',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
   },
 ];
